import React from 'react';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Components
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';
import WpIcon from 'Wpds/components/icon/WpIcon';
import SurfaceAIIntegrations from '../SurfaceAIIntegrations/SurfaceAIIntegrations';

// Styles
import './SurfaceAIEmptyState.scss';

type Props = {
  hasSurfaceIntegrations: boolean;
  hasSurfaceIntegrationThatIsLoading: boolean;
};

const SurfaceAIEmptyState = ({ hasSurfaceIntegrations, hasSurfaceIntegrationThatIsLoading }: Props) => {
  const [isIntegrationsOpen, toggleIntegrationsOpen] = useToggle(false);

  const baseClassName = 'SurfaceAIEmptyState';

  if (hasSurfaceIntegrations) {
    if (hasSurfaceIntegrationThatIsLoading)
      return (
        <div className={baseClassName}>
          <EmptyStateContainer
            title="Welcome to SurfaceAI"
            subTitle="We are still generating your data. Please refresh the page in a few minutes."
            button={
              <WpButtonGroup stacked>
                <WpButton onClick={() => location.reload()}>Refresh page</WpButton>
              </WpButtonGroup>
            }
          />
        </div>
      );
    return (
      <>
        <div className={baseClassName}>
          <EmptyStateContainer
            title="Welcome to SurfaceAI"
            subTitle="Your SurfaceAI feed does not have any data to show. Try connecting additional Integrations."
          />
          <div className={`${baseClassName}__integrations-list`}>
            <SurfaceAIIntegrations />
          </div>
        </div>
      </>
    );
  }

  return (
    <div className={baseClassName}>
      <EmptyStateContainer
        title="Welcome to SurfaceAI"
        subTitle="Connect integrations to see your team’s recent activity. You’ll see what’s actively being worked on and can proactively add them to workspaces as discussion topics."
        button={
          !isIntegrationsOpen && (
            <WpButtonGroup stacked>
              <WpButton onClick={toggleIntegrationsOpen}>Connect Integrations</WpButton>
            </WpButtonGroup>
          )
        }
      />
      {!isIntegrationsOpen && (
        <div>
          <WpIllustration
            className={`${baseClassName}__image`}
            src={Illustrations.integrations_ring}
            alt="Perform SurfaceAI Integrations"
          />
        </div>
      )}
      {isIntegrationsOpen && (
        <div className={`${baseClassName}__integrations-list`}>
          <SurfaceAIIntegrations
            button={
              <WpButton onClick={toggleIntegrationsOpen} variant="tertiary">
                <WpIcon name="angle-left" /> Back
              </WpButton>
            }
          />
        </div>
      )}
    </div>
  );
};

export default SurfaceAIEmptyState;
